import { Box } from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import Table from '../../TableResizable';
import DataPeriodAuto from "../../../Functions/Traitement/DataPeriodAuto";

const Tab5 = (props: { form?: any, DataPeriodAuto: DataPeriodAuto[] }) => {

 // DECLARATION DES COLONNES DU TABLEAU
const columns: ColumnsType<DataPeriodAuto> = [
    {
        title: 'Numero dossier',
        dataIndex: 'NUMCRD',
        ellipsis: true,
        width: 100,
    },
    {
        title: 'Indice Client',
        dataIndex: 'NUMCLI',
        ellipsis: true,
        width: 80,
    },
    {
        title: 'Nom client',
        dataIndex: 'NOMCLI',
        ellipsis: true,
        width: 100,
    },
    {
        title: 'Service',
        dataIndex: 'SERVGE',
        ellipsis: true,
        width: 100,
    },
    {
        title: 'Nature crédit',
        dataIndex: 'NATCRD',
        ellipsis: true,
        width: 100,
    },
    {
        title: 'Montant decouvert',
        dataIndex: 'MNTAUT',
        ellipsis: true,
        width: 100,
        align:"right"
    },
    {
        title: 'Date effet',
        dataIndex: 'DATEFF',
        ellipsis: true,
        width: 80,
    },
    {
        title: 'Date fin',
        dataIndex: 'DATEFIN',
        ellipsis: true,
        width: 80,
    }
];


    return (
        <div className='tabItem'>
            <div >
                <Box display={'flex'} fontStyle="inherit" width={"85%"} position={"absolute"} >
                    <Box fontStyle="inherit" className='border-left border'>
                        <legend>Autorisation </legend>
                        <Table size='small' dataSource={props.DataPeriodAuto} columns={columns} style={{ width: '100%' }} scroll={{ y: 350,x: 1300 }} />
                    </Box>
                </Box>
            </div>
        </div>

    );

}

export default Tab5;